module.exports = __webpack_public_path__ + "img/t2-7.e5aa24dc.svg";